module.exports = __webpack_public_path__ + "files/e7786a3233440f723d231f644aaffc0b.png";